import { ApiBase } from "~/extensions/api";
import { myPageStore } from "~/store/MyPageStore";
import { store } from "~/pages/taikyo/store/TaikyoStore";
export class TaikyoApi extends ApiBase {
    loadFlowGuideText() {
        return this.api.get(`message/taikyo/flow/${store.selectRoomSb}`);
    }
    loadPrecautionsText() {
        return this.api.get(`message/taikyo/precautions/${store.selectRoomSb}`);
    }
    loadEntryprecautionsText() {
        return this.api.get(`message/taikyo/entry/precautions/${store.selectRoomSb}`);
    }
    loadCompleteText() {
        return this.api.get("message/taikyo/complete");
    }
    loadEntryCompleteText() {
        return this.api.get("message/taikyo/entry/complete");
    }
    loadKaiyakuEntryCompleteText() {
        return this.api.get("message/kaiyaku/entry/complete");
    }
    find() {
        return this.api.get(`taikyo/find/${myPageStore.selectedNyukyokeiyaku.orgNyukyokeiyakuNo}`);
    }
    findNotificationSaveInfo(bulkTaikyoNo) {
        return this.api.get(`taikyonotification/save/find/${bulkTaikyoNo}`);
    }
    findForInput() {
        return this.api.get("taikyo/forInput");
    }
    insert(command) {
        return this.request(command);
    }
    getFlowGuideItems() {
        return this.api.get("taikyo/getFlow");
    }
}
